# THE /app CLIENT FOLLOWS THE DEVICE'S DARK MODE — card 6ac075e0270c80c6c2166c4a
# (owner 2026-10-02: "All the account and reports and sign up. Not login. Not
# the games. Even the loading app screen").
#
# Dark is on while BOTH hold: the device asks for it (prefers-color-scheme), and
# the screen on show is not light-only (LIGHT_ONLY: the login screens and the
# games). It is decided again on every navigation and whenever the device
# switches. When on:
#   - <html> carries `el-dark`, which defines color_scheme.scss's --el-dk-*
#     variables; a converted style reads var(--el-dk-…, <its light color>);
#   - the screen gets theme.coffee's darkTheme instead of the light theme.
# The boot loading screen goes dark before any of this runs, in views/index.ejs.
import React from 'react'
import { flushSync } from 'react-dom'
import { ThemeProvider } from '@mui/material/styles'
import theme, { darkTheme } from './theme.coffee'
import './color_scheme.scss'
import { DARK_QUERY, SCHEME_EVENT, darkFor, deviceIsDark, storedScheme, applyClass } from './color_scheme_rules.coffee'
export { LIGHT_ONLY, schemeColor, isDark, onSchemeChange, storedScheme, setScheme, nextScheme } from './color_scheme_rules.coffee'


# The shell's theme: follows the router and the device.
export class SchemeProvider extends React.Component
  constructor: (props) ->
    super props
    @state = {dark: @decide()}

  # Printing is light: a report printed from a dark device is for paper. The
  # switch is flushed before the browser takes its snapshot.
  decide: -> not @printing and darkFor(@props.router?.current?.name, deviceIsDark(), storedScheme())

  update: =>
    dark = @decide()
    applyClass dark
    @setState {dark} if dark != @state.dark

  beforePrint: =>
    @printing = true
    flushSync @update

  afterPrint: =>
    @printing = false
    @update()

  componentDidMount: ->
    applyClass @state.dark
    @unsubscribe = @props.router?.subscribe? @update
    @query = window.matchMedia?(DARK_QUERY)
    @query?.addEventListener?('change', @update)
    document.addEventListener SCHEME_EVENT, @update
    window.addEventListener 'beforeprint', @beforePrint
    window.addEventListener 'afterprint', @afterPrint

  componentWillUnmount: ->
    @unsubscribe?()
    @query?.removeEventListener?('change', @update)
    document.removeEventListener SCHEME_EVENT, @update
    window.removeEventListener 'beforeprint', @beforePrint
    window.removeEventListener 'afterprint', @afterPrint

  render: ->
    <ThemeProvider theme={if @state.dark then darkTheme else theme}>{@props.children}</ThemeProvider>
